export const state = () => ({
  nextPlaylistItem: null,
  currentContentId: null,
  scormDuration: 0,
  scormPosition: null,
  scormCompleted: false,
  sessionTimeResponse: null
});

export const mutations = {
  setNextPlaylistItem(state, payload) {
    state.nextPlaylistItem = payload;
  },

  setCurrentContentId(state, payload) {
    state.currentContentId = payload;
  },

  setScormTick(state, { duration, position }) {
    state.scormDuration = duration;
    state.scormPosition = position;
  },
  setScormCompleted(state) {
    state.scormCompleted = true;
  },
  setSessionTimeResponse(state, payload) {
    state.sessionTimeResponse = payload;
  }
};

export const actions = {
  setNextPlaylistItem({ commit }, items) {
    commit('setNextPlaylistItem', items);
  },

  setCurrentContentId({ commit }, id) {
    commit('setCurrentContentId', id);
  },

  listenToScormTick({ commit, state }) {
    window.addEventListener('message', (event) => {
      const isSameOriginMessage = event.origin.includes(window.location.host);

      if (isSameOriginMessage) return;

      const message = parseMessage(event.data);
      if (!message) return;

      console.log('Received message from SCORM Engine:', message);
      if (message.event === 'scormTick') {
        commit('setScormTick', {
          duration: message.data.duration,
          position: message.data.position
        });
      }

      if (message.event === 'onCompleted') {
        commit('setScormCompleted');
      }

      if (message.event === 'sessionTimeResponse' && message.data) {
        commit('setSessionTimeResponse', message.data);
      }
    });
  },

  async onClose({ state }) {
    return new Promise((resolve) => {
      window.addEventListener('message', (event) => {
        const isSameOriginMessage = event.origin.includes(window.location.host);

        if (isSameOriginMessage) {
          return;
        }

        const messageFromEngine = parseMessage(event.data);

        const messageIsFromSameContent =
          messageFromEngine.data.contentId === state.currentContentId;

        if (messageFromEngine.event === 'onClose' && messageIsFromSameContent) {
          resolve(messageFromEngine.data.isCompleted);
        }
      });
    });
  }
};
function parseMessage(data) {
  if (!data) return null;
  if (typeof data === 'string') {
    try {
      return JSON.parse(data);
    } catch {
      return null;
    }
  }
  if (typeof data === 'object') {
    return data;
  }
  return null;
}
